export default {
  LIST_FETCHED: 'SUPPORT_FETCHED',
  LIST_LOAD: 'SUPPORT_LOAD',
  ITEM_DETAIL: 'SUPPORT_DETAIL',
  BUTTON_LOAD: 'SUPPORT_BUTTON_LOAD',
};
